export function articleDetailsForSave(form, showDetails) {
  const rows = form.articleotherDetails || [];
  const hasDetails = rows.some(row => row.articleSalesOptionsID || row.isBaseRow || row.newBarcode || row.articleUnitID);
  const base = {
    articleSalesOptionsID: null, isActive: true, companyUnitId: 0, typeOfSales: 1,
    newBarcode: form.barcode || '', articleUnitID: form.unitId || '',
    articleUnitQty: 1, newSalesPrice: form.salePriceWithVat ?? 0,
  };
  if (!hasDetails) return [base];
  // Preserve the previous simple-edit price mapping, without dropping other rows.
  if (!showDetails) {
    const first = rows[0];
    return [{ ...first,
      articleSalesOptionsID: first.articleSalesOptionsID || null,
      isActive: first.isActive ?? true,
      companyUnitId: first.companyUnitId || 0,
      typeOfSales: first.typeOfSales || 1,
      newBarcode: base.newBarcode, articleUnitID: base.articleUnitID,
      articleUnitQty: first.articleUnitQty || 1,
      newSalesPrice: base.newSalesPrice,
    }, ...rows.slice(1)];
  }
  return rows;
}
